<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter" query-api="dn400DeliveryTaskQuery"
                                $_em-custom-vuex-mixin_vo="dn400Vo"
                                $_em-custom-vuex-mixin_filter="dn400Filter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryDeliveryTaskResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      query-api="dn400DeliveryTaskQuery"
                                      withCustomRowActions
                                      $_em-custom-vuex-mixin_vo="dn400Vo"
                                      $_em-custom-vuex-mixin_filter="dn400Filter"
                                      $_em-custom-vuex-mixin_entity="dn400Entity"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="gotoChild"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            @click="gotoChild(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template #left-header>
                                    <em-button type="save" custom-icon="fa fa-fw fa-lg fa-undo-alt"
                                        :disabled="actionDisabled('select')"
                                        custom-label="退回转交"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        :busy="onComplete"
                                        @click="returnTasks()"
                                        confirm-text="确定退回选中的转交任务？"
                                    >
                                    </em-button>
                                    <b-button
                                        variant="outline-primary"
                                        size="sm"
                                        :disabled="actionDisabled('selectOne')"
                                        @click="openCreateDispatch()"
                                    >
                                        创建点件需求
                                    </b-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="创建点件需求" :visible.sync="createDispatchVisible" :close-on-click-modal='false' append-to-body
                   @close='clearCreateForm'>
            <el-form :model="createForm" ref="createForm" label-width="auto" width="30%" :inline="true" :rules="rules">
                <el-form-item label="需求配送工位" prop="dispatchStation">
                    <el-input v-model="createForm.dispatchStation"></el-input>
                </el-form-item>
                <el-form-item label="需求配送时间" prop="dispatchPlanTime">
                    <el-date-picker v-model="createForm.dispatchPlanTime" type="datetime" placeholder="选择日期时间"
                                    value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="createDispatchVisible = false">取消</el-button>
                <el-button type="primary" @click="createDispatch()">创建</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    // Author Lin
    // Date 2021-05-24 20:46:26

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCommonGotoMixin from "@/mixin/em/common/goto";
    import emCommonApiMixin from "@/mixin/em/common/api";

    export default {
        name: "sithMesInventoryDn400DeliveryTaskListView",
        mixins: [emCommonListMixin,emCommonGotoMixin,emCommonApiMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        data() {
            return {
                onComplete:false,
                createDispatchVisible: false,
                createForm: {
                    dispatchStation: '',
                    dispatchPlanTime: ''
                },
                rules: {
                    dispatchStation: [{required: true, message: '请输入配送工位'}],
                    dispatchPlanTime: [{required: true, message: '请输入需求配送时间'}],
                },
            }
        },
        computed:{
            modelName(){
                return 'sithMesInventoryDeliveryTask'
            },
            checkedItems() {
                //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
                return this.$store.state[this.modelName]["checkedItemsDn400Vo"];
            },
            selectIds() {
                //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
                return this.$store.state[this.modelName]["checkedItemsDn400Vo"].join(",");
            },
        },
        methods: {
            gotoChild(row) {
                this.$_emGotoMixin_gotoHolderList("sithMesInventoryDeliveryMaterial"
                    , {deliveryTaskIdFilter: row.id}
                    , {deliveryTaskId: row.id}, false, {})
            },
            actionDisabled(type) {
                    // 删除按钮在一条记录都没选的时候禁用
                if (type === "select") {
                        return this.checkedItems && this.checkedItems.length === 0;
                }
                    // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
                else if (type === "selectOne") {
                    return this.checkedItems && this.checkedItems.length !== 1;
                }
            },
            returnTasks() {
                this.onComplete = true;
                let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/returnTasks?ids=${this.selectIds}`
                this.$_emApiMixin_post(url, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "退回成功");
                    this.$refs.emListFilter.doQuery()
                })
                .finally(() => this.onComplete = false)
            },
            openCreateDispatch() {
                this.createDispatchVisible = true;
            },
            clearCreateForm() {
                this.createForm.dispatchPlanTime = '';
                this.createForm.dispatchStation
                this.$refs["createForm"].resetFields();
            },
            createDispatch() {
                let self = this;
                self.$refs["createForm"].validate(valid => {
                    if (valid) {
                        let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryDeliveryTask")}/createDnDispatch?deliveryId=${self.selectIds}&station=${self.createForm.dispatchStation}&planTime=${self.createForm.dispatchPlanTime}`;
                        self.$_emApiMixin_post(url, {})
                            .then((request) => {
                                if (request.status === 200) {
                                    self.$message({
                                        message: "创建成功",
                                        type: "success",
                                    });
                                    self.$refs["emListFilter"].doQuery()
                                } else {
                                    self.$message({
                                        message: "创建失败",
                                        type: "error",
                                    });
                                }
                            }).finally(() => {
                            this.createDispatchVisible = false;
                        })
                    } else {
                        self.$message({
                            message: "数据不完整",
                            type: "error",
                        });
                        return;
                    }
                })
            }
        },
        mounted() {
            if (this.$route.query.hasOwnProperty('deliveryNo')) {
                this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('deliveryNoFilter', this.$route.query.deliveryNo);
            }
            this.$refs.emListFilter.doQuery();
        }
    };
</script>
